import React, { useState } from 'react';
import { AddCircle, DragIndicator, Edit, MoreVert, RemoveCircle } from '@material-ui/icons';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, Menu, MenuItem, Modal } from '@material-ui/core';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { allUIBuilderPagesSelector } from '../../../../property/propertySlice';
import { ASSET_URL } from '../../../../../env/Configurations';

const getModalStyle = () => {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
};

const useStyles = makeStyles((theme) => ({
  addNewPopup: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  gridItem: {
    width: 'calc(20% - 16px)',
    minWidth: '180px',
    marginBottom: '16px',
    boxSizing: 'border-box',
  },
}));

const HamburgerMenuListTable = (props) => {
  const {
    handleMenuClick,
    selectedValue,
    list,
    setList,
    setVisible,
    handleClose,
    handleEdit,
    handleRemove,
    handleDeactivate,
    onActiveDeActiveHamburgerMenu,
  } = props;
  const [viewModal, setViewModal] = useState(false);
  const [viewState, setViewState] = useState(null);
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const pageList = useSelector(allUIBuilderPagesSelector);

  const onClickOption = (e, currMenu) => {
    return handleMenuClick(e, currMenu);
  };

  const onCloseOption = () => {
    return handleClose();
  };

  const onClickEdit = (e, currMenu) => {
    return handleEdit(e, currMenu);
  };

  const onClickRemove = (e, currMenu) => {
    return handleRemove(e, currMenu);
  };

  const onClickDeactivate = (e, currMenu) => {
    if (currMenu.isActive) {
      return handleDeactivate(e, currMenu);
    }

    onActiveDeActiveHamburgerMenu(e, selectedValue?.menu?.isActive ? 'deactivate' : 'activate');
  };

  const handleView = (uiBuilderMenu) => {
    setViewModal(true);
    setViewState(uiBuilderMenu);
  };

  const onDragStart = (e, index) => {
    e.dataTransfer.setData('draggedIndex', index);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = (e, targetIndex) => {
    const sourceIndex = e.dataTransfer.getData('draggedIndex');
    if (sourceIndex == targetIndex) return;

    const newList = [...list];
    const [removedItem] = newList.splice(sourceIndex, 1);
    newList.splice(targetIndex, 0, removedItem);
    setList(newList);

    setVisible(true);
  };

  const page = pageList?.find((item) => item?.id === viewState?.pages[0]);

  return (
    <div className='col-12 mx-3 col-md-12 mt-1'>
      <Modal open={viewModal} onClose={() => setViewModal(false)}>
        <div style={modalStyle} className={`${classes.addNewPopup} p-4`}>
          <div className='col mt-3 row mx-0'>
            <div className='col col-md-6 px-0'>
              <h4
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  wordBreak: 'break-all',
                }}
              >
                {viewState?.name}
              </h4>
            </div>
            <div className='col col-md-6 d-flex justify-content-end px-0'>
              <Button
                variant='outlined'
                color='primary'
                size='small'
                onClick={(e) => {
                  setViewModal(false);
                  onClickEdit(e, viewState);
                }}
                style={{
                  height: '35px',
                }}
              >
                Edit
              </Button>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label bolder-text pb-1'>Icon</div>
            <div className='icon-view'>
              <div className='image-container'>
                <img src={ASSET_URL + viewState?.menuIconUrl} alt='' className='mb-2' />
              </div>
            </div>
          </div>
          <div className='col-md-12 mt-3'>
            <div className='details-label bolder-text'>Module Name</div>
            <div className='details-value' style={{ wordBreak: 'break-all' }}>
              {viewState?.name}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mt-4'>
              <div className='details-label bolder-text'>Category</div>
              <div className='details-value'>{viewState?.category}</div>
            </div>
            <div className='col-md-6 mt-4'>
              <div className='details-label bolder-text'>Redirect Option</div>
              <div className='details-value'>{viewState?.redirectOptions}</div>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label bolder-text'>Redirect to</div>
            <div
              className='details-value'
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-all',
              }}
            >
              {viewState?.flow || page?.name || viewState?.externalLink}
            </div>
          </div>
          <div>
            <Button
              variant='outlined'
              size='small'
              color='secondary'
              className='d-flex row m-auto mt-4'
              onClick={(e) => {
                setViewModal(false);
                onCloseOption();
              }}
            >
              {' '}
              Ok
            </Button>
          </div>
        </div>
      </Modal>
      <div className='col-12 col-md-12 w-100'>
        <div className={classes.gridContainer}>
          {list?.map((uiBuilderMenu, uiBuilderMenuIndex) => (
            <div
              key={uiBuilderMenu?.id}
              className={classes.gridItem}
              draggable
              onDragStart={(e) => onDragStart(e, uiBuilderMenuIndex)}
              onDragOver={onDragOver}
              onDrop={(e) => onDrop(e, uiBuilderMenuIndex)}
              style={{ opacity: !uiBuilderMenu?.isActive && '0.3' }}
            >
              <div className='hambuger-menu-list-table row flex-nowrap'>
                <div className='col-2'>
                  <div className='menu-icons-draggable-icon'>
                    <DragIndicator fontSize='large' />
                  </div>
                </div>
                <div className='col-8 text-center'>
                  <div className='row d-flex justify-content-center'>
                    <div className='image-container'>
                      <img src={ASSET_URL + uiBuilderMenu?.menuIconUrl} alt='' />
                    </div>
                  </div>
                  <div className='row d-flex justify-content-center'>
                    <div
                      style={{
                        width: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                      title={uiBuilderMenu?.name}
                    >
                      {uiBuilderMenu?.name}
                    </div>
                  </div>
                  <div className='row d-flex justify-content-center'>
                    {!uiBuilderMenu?.isActive ? '(Deactivated)' : ''}
                  </div>
                </div>
                <div
                  className='col-2 menu-icons-drop-down-icon'
                  onClick={(e) => onClickOption(e, uiBuilderMenu)}
                >
                  <MoreVert className='showpopupInner' fontSize='large' />
                </div>
                {selectedValue?.id === uiBuilderMenu?.id && (
                  <div className='ui-builder-menu-option-pop' disabled={'none'}>
                    <Menu
                      id={uiBuilderMenuIndex}
                      anchorEl={selectedValue?.anchorEl}
                      disableRestoreFocus
                      MenuListProps={{ autoFocusItem: false }}
                      keepMounted
                      open={Boolean(selectedValue.anchorEl)}
                      onClose={() => onCloseOption()}
                      className='shadow'
                      anchorOrigin={{
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        horizontal: 'left',
                        vertical: 'top',
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem className='pe-4' onClick={(e) => onClickEdit(e, uiBuilderMenu)}>
                        <Edit className='me-2 action-menu-icon' />
                        Edit
                      </MenuItem>
                      <MenuItem
                        className='pe-4'
                        onClick={() => {
                          handleView(uiBuilderMenu);
                        }}
                      >
                        <VisibilityIcon className='me-2 action-menu-icon' />
                        View
                      </MenuItem>
                      <MenuItem
                        className='pe-4'
                        onClick={(e) => {
                          onClickDeactivate(e, uiBuilderMenu);
                        }}
                      >
                        {selectedValue?.menu?.isActive ? (
                          <>
                            <RemoveCircle className='me-2 action-menu-icon' />
                            Deactivate
                          </>
                        ) : (
                          <>
                            <AddCircle className='me-2 action-menu-icon' />
                            Activate
                          </>
                        )}
                      </MenuItem>

                      <MenuItem className='pe-4' onClick={(e) => onClickRemove(e, uiBuilderMenu)}>
                        <DeleteForeverIcon className='me-2 action-menu-icon' />
                        Delete
                      </MenuItem>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenuListTable;
